class LsgCartReminderPopup extends HTMLElement {
  constructor() {
    super();
    this.ERROR_CLASS = 'is-invalid';
    this.currentStep = '1';

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onEmailInput = this.onEmailInput.bind(this);
    this.onPhoneInput = this.onPhoneInput.bind(this);

    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.onBannerClickDelegated = this.onBannerClickDelegated.bind(this);
  }

  connectedCallback() {
    this.overlay  = this.querySelector('#cart-reminder-popup-overlay');
    this.card     = this.querySelector('.cart-reminder-popup__card');
    this.closeBtn = this.querySelector('.cart-reminder-popup__close');

    document.addEventListener('click', this.onBannerClickDelegated);
    if (this.overlay)  this.overlay.addEventListener('click', this.onOverlayClick);
    if (this.closeBtn) this.closeBtn.addEventListener('click', this.onCloseClick);
    document.addEventListener('keydown', this.onKeydown);

    this.init();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onBannerClickDelegated);
    if (this.overlay)  this.overlay.removeEventListener('click', this.onOverlayClick);
    if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onCloseClick);
    document.removeEventListener('keydown', this.onKeydown);

    this.buttons?.forEach(btn => btn.removeEventListener('click', this.onButtonClick));
    if (this.emailInput) this.emailInput.removeEventListener('input', this.onEmailInput);
    if (this.phoneInput) this.phoneInput.removeEventListener('input', this.onPhoneInput);
  }

  open() {
    if (!this.overlay) return;
    this.overlay.classList.remove('hidden');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  close() {
    if (!this.overlay) return;
    this.overlay.classList.add('hidden');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  onBannerClickDelegated(e) {
    const btn = e.target instanceof Element
      ? e.target.closest('.lsg-cart__reminder-banner-cta')
      : null;
    if (!btn) return;

    e.preventDefault();
    this.open();
  }

  onOverlayClick(e) {
    if (this.card && !this.card.contains(e.target)) this.close();
  }
  onCloseClick(e) {
    e.preventDefault();
    this.close();
  }
  onKeydown(e) {
    if (e.key === 'Escape') this.close();
  }

  init() {
    this.steps = [...this.querySelectorAll('.js-step-container')];
    this.buttons = [...this.querySelectorAll('.js-step-button')];
    this.emailInput = this.querySelector('#email');
    this.phoneInput = this.querySelector('#phone');

    this.klaviyoProxyUrl = this.getAttribute('data-klaviyo-proxy') || '';
    this.klaviyoListId = this.getAttribute('data-klaviyo-list-id') || '';

    this.currentStep =
      this.steps.find(el => !el.classList.contains('hidden'))?.dataset.step || '1';

    this.buttons.forEach(btn => btn.addEventListener('click', this.onButtonClick));
    if (this.emailInput) this.emailInput.addEventListener('input', this.onEmailInput);
    if (this.phoneInput) this.phoneInput.addEventListener('input', this.onPhoneInput);
  }

  async onButtonClick(e) {
    const nextStep = e.currentTarget.dataset.step;

    if (this.currentStep === '1') {
      const ok = this.validEmail(this.emailInput?.value);
      if (!ok) { this.emailInput?.classList.add(this.ERROR_CLASS); return; }
      this.emailInput.classList.remove(this.ERROR_CLASS);
    }

    if (this.currentStep === '2') {
      const ok = this.validUSPhone(this.phoneInput?.value);
      if (!ok) { this.phoneInput?.classList.add(this.ERROR_CLASS); return; }
      this.phoneInput.classList.remove(this.ERROR_CLASS);

      if (String(nextStep) === '3') {
        try {
          const email = String(this.emailInput?.value || '').trim();
          const phone = this.normalizeUSPhone(this.phoneInput?.value);
          await this.subscribeToKlaviyo(email, phone);
        } catch (err) {
          this.phoneInput?.classList.add(this.ERROR_CLASS);
          return;
        }
      }
    }

    this.showStep(nextStep);
  }

  onEmailInput() {
    if (this.validEmail(this.emailInput?.value)) {
      this.emailInput.classList.remove(this.ERROR_CLASS);
    }
  }
  onPhoneInput() {
    if (this.validUSPhone(this.phoneInput?.value)) {
      this.phoneInput.classList.remove(this.ERROR_CLASS);
    }
  }
  showStep(step) {
    this.steps.forEach(el => el.classList.toggle('hidden', el.dataset.step !== String(step)));
    this.currentStep = String(step);
  }

  validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim().toLowerCase());
  }
  validUSPhone(v) {
    let d = String(v || '').replace(/\D/g, '');
    if (d.length === 11 && d[0] === '1') d = d.slice(1);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(d);
  }
  normalizeUSPhone(v) {
    let d = String(v || '').replace(/\D/g, '');
    if (d.length === 11 && d[0] === '1') d = d.slice(1);
    return `+1${d}`;
  }
  async subscribeToKlaviyo(email, phoneE164) {
    if (!this.klaviyoProxyUrl || !this.klaviyoListId) {
      throw new Error('Klaviyo config missing');
    }
    const res = await fetch(this.klaviyoProxyUrl, {
      method: 'POST',
      headers: {
        accept: 'application/json, text/plain, */*',
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: new URLSearchParams({g: this.klaviyoListId, email: email, phone_number: phoneE164})
    });
    if (!res.ok) throw new Error('Subscribe failed');
    return true;
  }
}

customElements.define('lsg-cart-reminder-popup', LsgCartReminderPopup);
